import React, { useState, useEffect, useContext, useRef } from 'react'
import { ReactReduxContext } from 'react-redux'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'
import { Spinner } from 'react-bootstrap'
import { invalidateUser } from 'helpers/auth'
import { profileNamesForLoggedArea } from 'helpers/tools'
import API_AUTH from 'store/modules/auth/api'
import CustomModal from 'components/molecules/CustomModal'
import '../ModalLogin/ModalLogin.scss'

function ModalLoggedUser(props) {
  const { store } = useContext(ReactReduxContext)
  const ref = useRef()
  const history = useHistory()
  const { active, user, handleOutSideMenuUser } = props

  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false)
  const [changePasswordStatus, setChangePasswordStatus] = useState(null)

  useEffect(() => {
    const checkIfClickedOutside = (event) => {
      if (active && ref.current && !ref.current?.contains(event.target) && !showChangePasswordModal) {
        handleOutSideMenuUser()
      }
    }
    document.addEventListener('mousedown', checkIfClickedOutside)
    return () => {
      document.removeEventListener('mousedown', checkIfClickedOutside)
    }
  }, [active, showChangePasswordModal])

  const openChangePasswordModal = () => {
    setChangePasswordStatus(null)
    setShowChangePasswordModal(true)
  }

  const closeChangePasswordModal = async () => {
    const shouldLogout = changePasswordStatus === 'success'
    setShowChangePasswordModal(false)
    setChangePasswordStatus(null)
    if (shouldLogout) {
      await invalidateUser(store)
      history.push('/login')
    }
  }

  const handleChangePassword = async () => {
    setChangePasswordStatus('loading')
    try {
      await API_AUTH.rememberPassword({ email: user?.email, resend: false })
      setChangePasswordStatus('success')
    } catch (error) {
      setChangePasswordStatus('error')
    }
  }

  const logout = async () => {
    await invalidateUser(store)
    history.push('/')
  }
  return (
    <>
      {active && (
        <section className="ModalLogin ModalLogin--logged">
          <div className="overlay" />
          <div className="container">
            <div className="ModalLogin__modal-box" ref={ref}>
              <div className="ModalLogin__content">
                <HashLink to="/change-profile">Trocar Perfil</HashLink>
                <HashLink to={`/app/home-${profileNamesForLoggedArea(user?.menu)}`}>Minha área de trabalho</HashLink>
              </div>

              <footer className="ModalLogin__footer">
                <button type="button" className="ModalLogin__change-password-btn" onClick={openChangePasswordModal}>
                  Alterar Senha
                </button>
                <button onClick={logout}>
                  Desconectar <i className="icone-logout" />
                </button>
              </footer>
            </div>
          </div>
        </section>
      )}

      <CustomModal
        open={showChangePasswordModal}
        closeModal={closeChangePasswordModal}
        size="sm"
        className="ModalChangePassword"
        alignCenter
        title="Alterar Senha"
        footer={
          changePasswordStatus === null
            ? {
                closeButton: true,
                button: {
                  text: 'Confirmar',
                  action: handleChangePassword,
                  noIcon: true,
                },
              }
            : { closeButton: true }
        }
      >
        {changePasswordStatus === null && (
          <p>
            Um e-mail de redefinição de senha será enviado para <strong>{user?.email}</strong>. Deseja continuar?
          </p>
        )}
        {changePasswordStatus === 'loading' && (
          <div className="text-center">
            <Spinner animation="border" />
          </div>
        )}
        {changePasswordStatus === 'success' && (
          <p>
            E-mail de redefinição de senha enviado com sucesso para <strong>{user?.email}</strong>.
          </p>
        )}
        {changePasswordStatus === 'error' && (
          <p>Ocorreu um erro ao solicitar a alteração de senha. Tente novamente mais tarde.</p>
        )}
      </CustomModal>
    </>
  )
}

ModalLoggedUser.propTypes = {
  active: PropTypes.bool.isRequired,
}

export default ModalLoggedUser
